// extracted by mini-css-extract-plugin
export default {"wrapper":"SbtInvalid_wrapper__jNHdr","message":"SbtInvalid_message__Vy8xE"};